export default "__VITE_ASSET__op$$bsS5__"